<template>
  <div id="myCarousel" class="carousel slide" data-ride="carousel" >
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
   
    <ol class="carousel-indicators" >
      <li data-target="#myCarousel"  v-for="(item, index) in images" :key="item.id" :class="{ active: index==0 }" :data-slide-to="index"></li>
    </ol>
    <div class="carousel-inner"  >
      <div class="carousel-item"  v-for="(item, index) in images" :key="item.id" :class="{ active: index==0 }" :id="item.id" @click="Go(item.link)" >
       
          <img :src="item.pc.src" style="display:none" :id="item.id" @load="onImgLoad"/>
          <img :src="item.mobile.src" style="display:none" :id="item.id" @load="onImgLoad"/>


          <div class="pc-imgshow" style="background-color: #333;
          background-position:  center center;
          background-repeat: no-repeat;
          background-size: cover;height: 100vh;" :style="{ 'background-image': 'url('+ item.pc.src+')' }"  v-if="imageLoaded">
          </div>

          <div  class="m-imgshow" style="background-color: #333;
          background-position:  center center;
          background-repeat: no-repeat;
          background-size: cover;" :style="{ 'background-image': 'url('+ item.mobile.src+')' }"   v-if="imageLoaded"></div>
          
      </div>
    </div>
      
    <button class="carousel-control-prev" type="button" data-target="#myCarousel" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-target="#myCarousel" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </button>
  </div>
</template>
<script>
import {fb, db } from '../../../firebase'
export default {
  name: 'Banner',
  data () {
    return {
        images:[],
        isLoading: false,
        fullPage: true,
        count:0,
        imageLoaded:false
    }
  },
  mounted () {
    this.Get();

  },
  methods: {
    Get(){
      this.isLoading = true;
      db.collection(this.$t('DB.BANNER')).get().then((querySnapshot) => {

        querySnapshot.forEach((doc) => {  
            var data = doc.data();
            var tmp = {
              id:     doc.id,
              link:   data.link,
              pc:{
                src: data.pc.src,
                name:'',
              },
              mobile:{
                src: data.mobile.src,
                name:'',
              }
            }
            if ( data.pc.src != '') this.images.push(tmp);
            
        });

      }).catch((error) => {
        this.isLoading = false;
      });


    },
    onImgLoad () {
      this.count++;
      if ( this.count == this.images.length ) {
        this.imageLoaded = true;
        this.isLoading = false;
      }
    },
    Go(val){

      if (val!='') window.open(val, '_blank');
    
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/Module/Banner.vue